module.exports = __webpack_public_path__ + "img/kontaktformular.2c9312b3.svg";